import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApartmentService } from 'src/app/_services/apartments/apartment.service';
import { FormControl, FormGroup,FormBuilder,  ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadFileService } from 'src/app/_services/UploadFile/upload-file.service';
import { Subscription } from 'rxjs';
import { Guid } from 'guid-typescript';

type Q = {
  id: string;
  question: string;
  answer: '' | 'yes' | 'no',
  comment?: string;
  images?:string[];
  __invalid?: boolean; 

}
 

interface Room {
  room_ID: string;
  room_Name: string;
  room_Devices: [];
}

@Component({
  selector: 'app-add-new-handover',
  templateUrl: './add-new-handover.component.html',
  styleUrls: ['./add-new-handover.component.scss']
})
export class AddNewHandoverComponent {




    apt_UUID: any;
 Rooms_Devices : any[]=[];
 Devices: Array<any> = [];
 selectedRooms: any;

  constructor(
    public _ApartmentService: ApartmentService,
    private router: Router,
    private messageService: MessageService,
    private uploadService: UploadFileService,
    private _ActivatedRoute: ActivatedRoute,
       private fb: FormBuilder,

  ) {
    this.apt_UUID = localStorage.getItem('Apartment_ID');
    const data = localStorage.getItem('generalInfoForm');
    if (data !== null) {
      let parsedData = JSON.parse(data);
      this.selectedRooms = parsedData.apartment_BedRoomsNo
    }


   }


  idParamterEdit:any=""
  ngOnInit() {
    this.apt_UUID = this._ActivatedRoute.snapshot.params['id']

      this.initializeRooms();
    

     ///////////////////////
     this.form = this.fb.group({
      description: ['', Validators.required]
    });

      

  }

////////////////////file upload////////////////
kitchenPhotos: string[] = [];
bathroomPhotos: string[] = [];
bedroom1Photos: string[] = [];
livingRoomPhotos:string[]=[]

Q1kitchen: string[] = [];
Q2kitchen: string[] = [];
Q3kitchen: string[] = [];
Q4kitchen:string[]=[]
Q5kitchen: string[] = [];
Q6kitchen: string[] = [];
Q7kitchen: string[] = [];
Q8kitchen:string[]=[]

onKitchenPhotosUpload(event: any) {
  const files: File[] = event.files;

  files.forEach(file => {
    const formData = new FormData();
    formData.append('fileData', file);

    this.uploadService.uploadSingleFile(formData).subscribe({
      next: (res: any) => {
        const fileUrl = res[0]?.file_Path;
        if (fileUrl) {
          this.kitchenPhotos.push(fileUrl); // ⬅️ خزّن الرابط
        }
      },
      error: (err) => console.error('Upload failed', err)
    });
  });
}


logImages() {
  console.log('Kitchen Photos:', this.kitchenPhotos);
  console.log('Bathroom Photos:', this.bathroomPhotos)
  console.log('Bedroom 1 Photos:', this.bedroom1Photos);
  
  console.log('Living Room Photos:', this.livingRoomPhotos);
}
//////////////////////////////////////question////////////////////////////////////////////////////////
 form!: FormGroup;
  selectedOption: string | null = null;

  
  onAnswerChange(value: string) {
    this.selectedOption = value;
  }

  ////////// text area
  get descriptionLength(): number {
    const value = this.form.get('description')?.value || '';
    // Remove extra spaces + split by space
    const words = value.trim().split(/\s+/);
    return value.trim() === '' ? 0 : words.length;
  }

  checkWordLimit() {
    const control = this.form.get('description');
    const value = control?.value || '';
    const words = value.trim().split(/\s+/);

    if (words.length > 100) {
      // لو زاد، احذف الكلمات الزيادة
      control?.setValue(words.slice(0, 100).join(' '));
    }
  }

      
  
  // لكل غرفة (kitchen, bathroom...)
roomQuestions:any = {
  kitchen: [
    {
      id: 'Q1',
      question: 'Are all cabinets and drawers in good condition?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q2',
      question: 'Is the sink working properly without leaks?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'Q3',
      question: 'Are all appliances (stove, oven, hood, etc.) functioning?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'Q5',
      question: 'Is the heating system working correctly?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'Q7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '', // yes | no
      comment: '',
      images: <string[]>[]
    },
    {
      id: 'Q8',
      question: 'Are the floors in good condition (no damage or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     
  ],
  bathroom: [
    {
      id: 'B1',
      question: 'Is the toilet working properly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
     {
      id: 'B2',
      question: 'Is the sink working properly without leaks?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
       {
      id: 'B3',
      question: 'Is the mirror in good condition?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
        {
      id: 'B4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
         {
      id: 'B5',
      question: 'Is the heating system working correctly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
          {
      id: 'B6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
          {
      id: 'B7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
           {
      id: 'B8',
      question: 'Are the floors in good condition (no damage or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
    
  ],
  bedroom:[
          {
      id: 'C1',
      question: 'Is the bed and matters in good condition?',
      answer: '',
      comment: '',
      images:<string[]> []
    },
         {
      id: 'C2',
      question: 'Are all light fixtures working properly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
         {
      id: 'C3',
      question: 'Are the floors clean and undamaged ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
          {
      id: 'C4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
           {
      id: 'C5',
      question: 'Is the heating system working correctly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
              {
      id: 'C6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images:<string[]> []
    },
              {
      id: 'C7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
    
  ],
  livingRoom:[
                 {
      id: 'D1',
      question: 'Are the walls in good condition (no cracks, stains, or damage)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                  {
      id: 'D2',
      question: 'Are the floors clean and undamaged ?',
      answer: '',
      comment: '',
      images:<string[]> []
    },

                    {
      id: 'D3',
      question: 'Are the furniture pieces in good condition?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                      {
      id: 'D4',
      question: 'Are all windows opening and closing smoothly ?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },

                         {
      id: 'D5',
      question: 'Is the heating system working correctly?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                          {
      id: 'D6',
      question: 'Is the ceiling in good condition (no leaks or cracks)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                              {
      id: 'D7',
      question: 'Are the walls in good condition (no cracks or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
                              {
      id: 'D8',
      question: 'Are the floors in good condition (no damage or stains)?',
      answer: '',
      comment: '',
      images: <string[]>[]
    },
  ]
}

showSide:any
 addItem(value: any) {
    this.showSide = value;
  }


submitHandover(){
  const validation = this.validateAllQuestions();
  if(!validation.ok) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Complete all questions',
      detail: 
          'Please answer all question. Missing: ' +
          validation.errors.slice(0,4).join(', ') +
          (validation.errors.length > 4 ? ' ...' : '')
    });
    return;
  }
  /////////////////////////////////////////////////////////////////
  const apartment_ID = this.apt_UUID;
  const handover_Created_at =new Date().toISOString();

  const getPlaceId = (keyword: string) => {
    // const match = this.roomsHandover?.find((room: any) => {
    //   room.some((device: any) => device.device_Name?.toLowerCase().includes(keyword))
    // });
  const match = this.roomsHandover?.find((room: any) =>
    room.room_Name?.toLowerCase().includes(keyword.toLowerCase())
  );
    return match?.room_ID || crypto.randomUUID();
  };

  const places = [
    {
      place_ID: getPlaceId('Kitchen'),
      place_Name:'Kitchen',
      place_Images:this.kitchenPhotos,
      handover_Questions_Json: JSON.stringify(this.roomQuestions.kitchen)
    },
    {
      place_ID: getPlaceId('bathroom'),
      place_Name:'Bathroom',
      place_Images: this.bathroomPhotos,
      handover_Questions_Json: JSON.stringify(this.roomQuestions.bathroom)
    },
    {
      place_ID: getPlaceId('living'),
      place_Name: 'Living Room',
      place_Images: this.livingRoomPhotos,
      handover_Questions_Json: JSON.stringify(this.roomQuestions.livingRoom)
    },
      // 🛏 Bedrooms with dynamic place name and per-room copy of questions
    ...this.getbedrooms.map((room: any) => ({
      place_ID: room.room_ID,
      place_Name: 'Bedroom (' + room.room_Name + ')',
      place_Images: room.place_Images || [],
      handover_Questions_Json: JSON.stringify(room.questions)
    }))
   ]

   const payload = {
    apartment_ID,
    handover_Created_at,
    places
   }

   console.log('🟢 Final Payload', payload);

   this._ApartmentService.addNewHandover(payload).subscribe({
    next: res => {
      console.log('✅ Sent successfully', res)

              this.messageService.add({ severity: 'success', summary: 'Success', detail: `${ res.message|| 'Handover added Successfuly'}` });
    
    },
    error: err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `${ err.message ||'Please try again'}` });
      console.error('❌ Error sending handover', err)
    }
   })
   
}


// get bedrooms() {
//   if (!this.roomsHandover) return [];

//   const bedroomKeywords = ['single', 'double', 'trible', 'shared'];
//   return this.roomsHandover.filter((room: any) => {
//     const name = room.room_Name?.toLowerCase() || '';
//     return bedroomKeywords.some(type => name.includes(type));
//   });
// }

get bedrooms() {
  if (!this.roomsHandover) return [];

  const bedroomKeywords = ['single', 'double', 'trible', 'shared'];
  return this.roomsHandover
    .filter((room: any) => {
      const name = room.room_Name?.toLowerCase() || '';
      return bedroomKeywords.some(type => name.includes(type));
    })
    .map((room: any) => ({
      room_ID: room.room_ID,
      room_Name: room.room_Name,
      place_Images: <string[]>[],
     
    }));
}

private deepClone(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}



////////////////make all questions required//////////////////////
 private questionIsValid(q: Q):boolean {
  if(!q?.answer) return false;

  if(q.answer === 'no'){
    const hasComment = !!q.comment?.trim();
    const hasImages =!!q.images && q.images.length > 0;
    return hasComment || hasImages;
  }

  return true;
 }

 private validateAllQuestions():{ok: boolean; errors: string[]}{
    const errors: string[] = [];

   const checkSection =(list: Q[], sectionName: string) => {
    const arr = Array.isArray(list) ? list : []; ///protection from undefined
    arr.forEach((q, idx) => {
      const valid = this.questionIsValid(q);
      q.__invalid=!valid;

      if(!valid) errors.push(`${sectionName} → ${'Q' + (idx + 1)}`)
    });
   };

    checkSection(this.roomQuestions.kitchen as Q[], 'Kitchen');
    checkSection(this.roomQuestions.bathroom as Q[], 'Bathroom');
    checkSection(this.roomQuestions.livingRoom as Q[], 'Living Room');


    this.getbedrooms.forEach((room: any) => {
      checkSection(room.questions as Q[], `Bedroom (${room.room_Name})`);
    })


    return {ok: errors.length === 0, errors};


 }
  
///////////////fill handover section with data coming from details////////////////////////////
 

 room_Devices : any[] = [];
  rooms: any[] = [];
  public roomIndexValue :any;

roomsHandover:any[]=[]
getbedrooms:any[]=[]

 initializeRooms() {

    this._ApartmentService.getRoomDevices(this.apt_UUID).subscribe({
      next:(res)=>{
        console.log(res)
        this.roomsHandover=res
        /////////////////////////////////////////
         const bedroomKeywords = ['single', 'double', 'trible', 'shared'];
  this.getbedrooms = this.roomsHandover
    .filter((room: any) => {
      const name = room.room_Name?.toLowerCase() || '';
      return bedroomKeywords.some(type => name.includes(type));
    })
    .map((room: any) => ({
      room_ID: room.room_ID,
      room_Name: room.room_Name,
      place_Images: <string[]>[],
      questions: this.deepClone(this.roomQuestions.bedroom) // ⬅️ نسخة مستقلة من الأسئلة لكل غرفة
    }));
        //////////////////////////////////////////
        console.log('🛏️ Filtered Bedrooms:', this.getbedrooms);
     


      }
    })
  }

}
